import Vue from 'vue'
import { library, config } from '@fortawesome/fontawesome-svg-core'
import {
  FontAwesomeLayers,
  FontAwesomeLayersText,
  FontAwesomeIcon
} from '@fortawesome/vue-fontawesome'

import {
  faAmazon as freeFabFaAmazon
} from '@fortawesome/free-brands-svg-icons'

import {
  faAddressBook as proFarFaAddressBook,
  faAddressCard as proFarFaAddressCard,
  faAngleDown as proFarFaAngleDown,
  faAngleRight as proFarFaAngleRight,
  faAngleUp as proFarFaAngleUp,
  faArrowAltCircleRight as proFarFaArrowAltCircleRight,
  faArrowDownLong as proFarFaArrowDownLong,
  faArrowLeft as proFarFaArrowLeft,
  faArrowRightLong as proFarFaArrowRightLong,
  faArrowUpLong as proFarFaArrowUpLong,
  faArrowUpRightFromSquare as proFarFaArrowUpRightFromSquare,
  faAsterisk as proFarFaAsterisk,
  faAward as proFarFaAward,
  faBackpack as proFarFaBackpack,
  faBadgeCheck as proFarFaBadgeCheck,
  faBallot as proFarFaBallot,
  faBars as proFarFaBars,
  faBlind as proFarFaBlind,
  faBriefcase as proFarFaBriefcase,
  faBriefcaseMedical as proFarFaBriefcaseMedical,
  faBuilding as proFarFaBuilding,
  faBuildings as proFarFaBuildings,
  faCalendar as proFarFaCalendar,
  faCalendarCheck as proFarFaCalendarCheck,
  faCalendarDay as proFarFaCalendarDay,
  faCalendarDays as proFarFaCalendarDays,
  faCalendarPlus as proFarFaCalendarPlus,
  faCalendarWeek as proFarFaCalendarWeek,
  faCalendarXmark as proFarFaCalendarXmark,
  faCar as proFarFaCar,
  faCarBattery as proFarFaCarBattery,
  faCarBuilding as proFarFaCarBuilding,
  faCarBump as proFarFaCarBump,
  faCarBurst as proFarFaCarBurst,
  faCarMirrors as proFarFaCarMirrors,
  faCarSide as proFarFaCarSide,
  faChartLine as proFarFaChartLine,
  faChartLineUp as proFarFaChartLineUp,
  faChartMixed as proFarFaChartMixed,
  faCheck as proFarFaCheck,
  faCheckSquare as proFarFaCheckSquare,
  faChevronDown as proFarFaChevronDown,
  faChevronUp as proFarFaChevronUp,
  faChild as proFarFaChild,
  faCircle as proFarFaCircle,
  faCircleBolt as proFarFaCircleBolt,
  faCircleCheck as proFarFaCircleCheck,
  faCircleDot as proFarFaCircleDot,
  faCircleInfo as proFarFaCircleInfo,
  faCircleLeft as proFarFaCircleLeft,
  faCircleMinus as proFarFaCircleMinus,
  faCircleRight as proFarFaCircleRight,
  faCircleSmall as proFarFaCircleSmall,
  faCircleUser as proFarFaCircleUser,
  faCircleXmark as proFarFaCircleXmark,
  faClawMarks as proFarFaClawMarks,
  faClipboardMedical as proFarFaClipboardMedical,
  faClock as proFarFaClock,
  faClockFive as proFarFaClockFive,
  faClockNine as proFarFaClockNine,
  faClockOne as proFarFaClockOne,
  faClockThree as proFarFaClockThree,
  faClose as proFarFaClose,
  faCoin as proFarFaCoin,
  faCoins as proFarFaCoins,
  faComment as proFarFaComment,
  faCreditCard as proFarFaCreditCard,
  faCreditCardFront as proFarFaCreditCardFront,
  faDesktop as proFarFaDesktop,
  faDoorOpen as proFarFaDoorOpen,
  faDotCircle as proFarFaDotCircle,
  faDownLong as proFarFaDownLong,
  faDownload as proFarFaDownload,
  faEarthEurope as proFarFaEarthEurope,
  faEnvelope as proFarFaEnvelope,
  faEuroSign as proFarFaEuroSign,
  faEye as proFarFaEye,
  faFaceSmileHearts as proFarFaFaceSmileHearts,
  faFan as proFarFaFan,
  faFileAlt as proFarFaFileAlt,
  faFileCertificate as proFarFaFileCertificate,
  faFileContract as proFarFaFileContract,
  faFileInvoice as proFarFaFileInvoice,
  faFileLines as proFarFaFileLines,
  faFilePdf as proFarFaFilePdf,
  faFire as proFarFaFire,
  faFireAlt as proFarFaFireAlt,
  faFireExtinguisher as proFarFaFireExtinguisher,
  faFlag as proFarFaFlag,
  faForwardFast as proFarFaForwardFast,
  faFutbol as proFarFaFutbol,
  faGarageCar as proFarFaGarageCar,
  faGauge as proFarFaGauge,
  faGaugeMax as proFarFaGaugeMax,
  faGaugeSimple as proFarFaGaugeSimple,
  faGaugeSimpleMax as proFarFaGaugeSimpleMax,
  faGaugeSimpleMed as proFarFaGaugeSimpleMed,
  faGear as proFarFaGear,
  faGem as proFarFaGem,
  faGlasses as proFarFaGlasses,
  faGifts as proFarFaGifts,
  faGraduationCap as proFarFaGraduationCap,
  faHandHoldingMedical as proFarFaHandHoldingMedical,
  faHandsHelping as proFarFaHandsHelping,
  faHandshake as proFarFaHandshake,
  faHandPointUp as proFarFaHandPointUp,
  faHeart as proFarFaHeart,
  faHeartPulse as proFarFaHeartPulse,
  faHeadphones as proFarFaHeadphones,
  faHeadphonesSimple as proFarFaHeadphonesSimple,
  faHospitalUser as proFarFaHospitalUser,
  faHouse as proFarFaHouse,
  faHouseChimney as proFarFaHouseChimney,
  faHouseChimneyCrack as proFarFaHouseChimneyCrack,
  faHouseCrack as proFarFaHouseCrack,
  faHouseHeart as proFarFaHouseHeart,
  faHouseMedical as proFarFaHouseMedical,
  faHouseMedicalFlag as proFarFaHouseMedicalFlag,
  faHousePersonReturn as proFarFaHousePersonReturn,
  faHouseSignal as proFarFaHouseSignal,
  faHouseUser as proFarFaHouseUser,
  faHospitals as proFarFaHospitals,
  faIdCard as proFarFaIdCard,
  faKey as proFarFaKey,
  faKitMedical as proFarFaKitMedical,
  faLampFloor as proFarFaLampFloor,
  faLaptop as proFarFaLaptop,
  faLaptopHouse as proFarFaLaptopHouse,
  faLeaf as proFarFaLeaf,
  faLifeRing as proFarFaLifeRing,
  faLightbulb as proFarFaLightbulb,
  faLightbulbOn as proFarFaLightbulbOn,
  faLink as proFarFaLink,
  faListAlt as proFarFaListAlt,
  faLocationDot as proFarFaLocationDot,
  faLock as proFarFaLock,
  faLockKeyhole as proFarFaLockKeyhole,
  faMagnifyingGlass as proFarFaMagnifyingGlass,
  faMagnifyingGlassChart as proFarFaMagnifyingGlassChart,
  faMapPin as proFarFaMapPin,
  faMedal as proFarFaMedal,
  faMemoPad as proFarFaMemoPad,
  faMessageLines as proFarFaMessageLines,
  faMessages as proFarFaMessages,
  faMessagesQuestion as proFarFaMessagesQuestion,
  faMinus as proFarFaMinus,
  faMobile as proFarFaMobile,
  faMobileScreenButton as proFarFaMobileScreenButton,
  faMoneyBill as proFarFaMoneyBill,
  faMoneyBillWave as proFarFaMoneyBillWave,
  faMoneyBills as proFarFaMoneyBills,
  faMoneyCheck as proFarFaMoneyCheck,
  faMoneyFromBracket as proFarFaMoneyFromBracket,
  faNetworkWired as proFarFaNetworkWired,
  faNewspaper as proFarFaNewspaper,
  faNoteMedical as proFarFaNoteMedical,
  faNotesMedical as proFarFaNotesMedical,
  faPaperPlane as proFarFaPaperPlane,
  faPause as proFarFaPause,
  faPenSwirl as proFarFaPenSwirl,
  faPenToSquare as proFarFaPenToSquare,
  faPercent as proFarFaPercent,
  faPercentage as proFarFaPercentage,
  faPersonRunning as proFarFaPersonRunning,
  faPersonSimple as proFarFaPersonSimple,
  faPeopleSimple as proFarFaPeopleSimple,
  faPhone as proFarFaPhone,
  faPiggyBank as proFarFaPiggyBank,
  faPlug as proFarFaPlug,
  faPlay as proFarFaPlay,
  faPlus as proFarFaPlus,
  faPodcast as proFarFaPodcast,
  faQuestionCircle as proFarFaQuestionCircle,
  faRectangleAd as proFarFaRectangleAd,
  faRectangleList as proFarFaRectangleList,
  faReceipt as proFarFaReceipt,
  faRepeatAlt as proFarFaRepeatAlt,
  faRightFromBracket as proFarFaRightFromBracket,
  faRightLeft as proFarFaRightLeft,
  faRouter as proFarFaRouter,
  faSack as proFarFaSack,
  faSackDollar as proFarFaSackDollar,
  faScaleBalanced as proFarFaScaleBalanced,
  faScaleUnbalancedFlip as proFarFaScaleUnbalancedFlip,
  faSensorAlert as proFarFaSensorAlert,
  faSensorOn as proFarFaSensorOn,
  faShareFromSquare as proFarFaShareFromSquare,
  faShield as proFarFaShield,
  faShieldCheck as proFarFaShieldCheck,
  faShoppingBasket as proFarFaShoppingBasket,
  faShoppingCart as proFarFaShoppingCart,
  faSignature as proFarFaSignature,
  faSimCard as proFarFaSimCard,
  faSirenOn as proFarFaSirenOn,
  faSliders as proFarFaSliders,
  faSpinnerThird as proFarFaSpinnerThird,
  faSquare as proFarFaSquare,
  faSquareCheck as proFarFaSquareCheck,
  faSquareH as proFarFaSquareH,
  faSquarePollVertical as proFarFaSquarePollVertical,
  faStar as proFarFaStar,
  faStethoscope as proFarFaStethoscope,
  faStopwatch as proFarFaStopwatch,
  faTag as proFarFaTag,
  faTemperatureLow as proFarFaTemperatureLow,
  faThoughtBubble as proFarFaThoughtBubble,
  faThumbsUp as proFarFaThumbsUp,
  faTireFlat as proFarFaTireFlat,
  faTowerBroadcast as proFarFaTowerBroadcast,
  faTrashCan as proFarFaTrashCan,
  faTree as proFarFaTree,
  faTrophy as proFarFaTrophy,
  faTriangleExclamation as proFarFaTriangleExclamation,
  faTruckFast as proFarFaTruckFast,
  faTruckRamp as proFarFaTruckRamp,
  faTruckRampCouch as proFarFaTruckRampCouch,
  faTv as proFarFaTv,
  faTvRetro as proFarFaTvRetro,
  faUmbrellaBeach as proFarFaUmbrellaBeach,
  faUpLong as proFarFaUpLong,
  faUpload as proFarFaUpload,
  faUser as proFarFaUser,
  faUserCircle as proFarFaUserCircle,
  faUserDoctor as proFarFaUserDoctor,
  faUserGear as proFarFaUserGear,
  faUserGroup as proFarFaUserGroup,
  faUserHeadset as proFarFaUserHeadset,
  faUserLock as proFarFaUserLock,
  faUserPlus as proFarFaUserPlus,
  faUserShield as proFarFaUserShield,
  faUserTag as proFarFaUserTag,
  faUsersMedical as proFarFaUsersMedical,
  faVanShuttle as proFarFaVanShuttle,
  faVault as proFarFaVault,
  faWallet as proFarFaWallet,
  faWifi as proFarFaWifi,
  faXmark as proFarFaXmark,
  faScrewdriverWrench as proFarFaScrewdriverWrench
} from '@fortawesome/pro-regular-svg-icons'

library.add(
  freeFabFaAmazon,
  proFarFaAddressBook,
  proFarFaAddressCard,
  proFarFaAngleDown,
  proFarFaAngleRight,
  proFarFaAngleUp,
  proFarFaArrowAltCircleRight,
  proFarFaArrowDownLong,
  proFarFaArrowLeft,
  proFarFaArrowRightLong,
  proFarFaArrowUpLong,
  proFarFaArrowUpRightFromSquare,
  proFarFaAsterisk,
  proFarFaAward,
  proFarFaBackpack,
  proFarFaBadgeCheck,
  proFarFaBallot,
  proFarFaBars,
  proFarFaBlind,
  proFarFaBriefcase,
  proFarFaBriefcaseMedical,
  proFarFaBuilding,
  proFarFaBuildings,
  proFarFaCalendar,
  proFarFaCalendarCheck,
  proFarFaCalendarDay,
  proFarFaCalendarDays,
  proFarFaCalendarPlus,
  proFarFaCalendarWeek,
  proFarFaCalendarXmark,
  proFarFaCar,
  proFarFaCarBattery,
  proFarFaCarBuilding,
  proFarFaCarBump,
  proFarFaCarBurst,
  proFarFaCarMirrors,
  proFarFaCarSide,
  proFarFaChartLine,
  proFarFaChartLineUp,
  proFarFaChartMixed,
  proFarFaCheck,
  proFarFaCheckSquare,
  proFarFaChevronDown,
  proFarFaChevronUp,
  proFarFaChild,
  proFarFaCircle,
  proFarFaCircleBolt,
  proFarFaCircleCheck,
  proFarFaCircleDot,
  proFarFaCircleInfo,
  proFarFaCircleLeft,
  proFarFaCircleMinus,
  proFarFaCircleRight,
  proFarFaCircleSmall,
  proFarFaCircleUser,
  proFarFaCircleXmark,
  proFarFaClawMarks,
  proFarFaClipboardMedical,
  proFarFaClock,
  proFarFaClockFive,
  proFarFaClockNine,
  proFarFaClockOne,
  proFarFaClockThree,
  proFarFaClose,
  proFarFaCoin,
  proFarFaCoins,
  proFarFaComment,
  proFarFaCreditCard,
  proFarFaCreditCardFront,
  proFarFaDesktop,
  proFarFaDoorOpen,
  proFarFaDotCircle,
  proFarFaDownLong,
  proFarFaDownload,
  proFarFaEarthEurope,
  proFarFaEnvelope,
  proFarFaEuroSign,
  proFarFaEye,
  proFarFaFaceSmileHearts,
  proFarFaFan,
  proFarFaFileAlt,
  proFarFaFileCertificate,
  proFarFaFileContract,
  proFarFaFileInvoice,
  proFarFaFileLines,
  proFarFaFilePdf,
  proFarFaFire,
  proFarFaFireAlt,
  proFarFaFireExtinguisher,
  proFarFaFlag,
  proFarFaForwardFast,
  proFarFaFutbol,
  proFarFaGarageCar,
  proFarFaGauge,
  proFarFaGaugeMax,
  proFarFaGaugeSimple,
  proFarFaGaugeSimpleMax,
  proFarFaGaugeSimpleMed,
  proFarFaGear,
  proFarFaGem,
  proFarFaGlasses,
  proFarFaGifts,
  proFarFaGraduationCap,
  proFarFaHandHoldingMedical,
  proFarFaHandsHelping,
  proFarFaHandshake,
  proFarFaHandPointUp,
  proFarFaHeart,
  proFarFaHeartPulse,
  proFarFaHeadphones,
  proFarFaHeadphonesSimple,
  proFarFaHospitalUser,
  proFarFaHouse,
  proFarFaHouseChimney,
  proFarFaHouseChimneyCrack,
  proFarFaHouseCrack,
  proFarFaHouseHeart,
  proFarFaHouseMedical,
  proFarFaHouseMedicalFlag,
  proFarFaHousePersonReturn,
  proFarFaHouseSignal,
  proFarFaHouseUser,
  proFarFaHospitals,
  proFarFaIdCard,
  proFarFaKey,
  proFarFaKitMedical,
  proFarFaLampFloor,
  proFarFaLaptop,
  proFarFaLaptopHouse,
  proFarFaLeaf,
  proFarFaLifeRing,
  proFarFaLightbulb,
  proFarFaLightbulbOn,
  proFarFaLink,
  proFarFaListAlt,
  proFarFaLocationDot,
  proFarFaLock,
  proFarFaLockKeyhole,
  proFarFaMagnifyingGlass,
  proFarFaMagnifyingGlassChart,
  proFarFaMapPin,
  proFarFaMedal,
  proFarFaMemoPad,
  proFarFaMessageLines,
  proFarFaMessages,
  proFarFaMessagesQuestion,
  proFarFaMinus,
  proFarFaMobile,
  proFarFaMobileScreenButton,
  proFarFaMoneyBill,
  proFarFaMoneyBillWave,
  proFarFaMoneyBills,
  proFarFaMoneyCheck,
  proFarFaMoneyFromBracket,
  proFarFaNetworkWired,
  proFarFaNewspaper,
  proFarFaNoteMedical,
  proFarFaNotesMedical,
  proFarFaPaperPlane,
  proFarFaPause,
  proFarFaPenSwirl,
  proFarFaPenToSquare,
  proFarFaPercent,
  proFarFaPercentage,
  proFarFaPersonRunning,
  proFarFaPersonSimple,
  proFarFaPeopleSimple,
  proFarFaPhone,
  proFarFaPiggyBank,
  proFarFaPlug,
  proFarFaPlay,
  proFarFaPlus,
  proFarFaPodcast,
  proFarFaQuestionCircle,
  proFarFaRectangleAd,
  proFarFaRectangleList,
  proFarFaReceipt,
  proFarFaRepeatAlt,
  proFarFaRightFromBracket,
  proFarFaRightLeft,
  proFarFaRouter,
  proFarFaSack,
  proFarFaSackDollar,
  proFarFaScaleBalanced,
  proFarFaScaleUnbalancedFlip,
  proFarFaSensorAlert,
  proFarFaSensorOn,
  proFarFaShareFromSquare,
  proFarFaShield,
  proFarFaShieldCheck,
  proFarFaShoppingBasket,
  proFarFaShoppingCart,
  proFarFaSignature,
  proFarFaSimCard,
  proFarFaSirenOn,
  proFarFaSliders,
  proFarFaSpinnerThird,
  proFarFaSquare,
  proFarFaSquareCheck,
  proFarFaSquareH,
  proFarFaSquarePollVertical,
  proFarFaStar,
  proFarFaStethoscope,
  proFarFaStopwatch,
  proFarFaTag,
  proFarFaTemperatureLow,
  proFarFaThoughtBubble,
  proFarFaThumbsUp,
  proFarFaTireFlat,
  proFarFaTowerBroadcast,
  proFarFaTrashCan,
  proFarFaTree,
  proFarFaTrophy,
  proFarFaTriangleExclamation,
  proFarFaTruckFast,
  proFarFaTruckRamp,
  proFarFaTruckRampCouch,
  proFarFaTv,
  proFarFaTvRetro,
  proFarFaUmbrellaBeach,
  proFarFaUpLong,
  proFarFaUpload,
  proFarFaUser,
  proFarFaUserCircle,
  proFarFaUserDoctor,
  proFarFaUserGear,
  proFarFaUserGroup,
  proFarFaUserHeadset,
  proFarFaUserLock,
  proFarFaUserPlus,
  proFarFaUserShield,
  proFarFaUserTag,
  proFarFaUsersMedical,
  proFarFaVanShuttle,
  proFarFaVault,
  proFarFaWallet,
  proFarFaWifi,
  proFarFaXmark,
  proFarFaScrewdriverWrench
)

config.autoAddCss = false

Vue.component('fa', FontAwesomeIcon)
Vue.component('faLayers', FontAwesomeLayers)
Vue.component('faLayersText', FontAwesomeLayersText)
